// `_links` is what the API emits and what useQueryList reads; the previous `links` was never read.
export const mockDisbursementsList = {
  data: [
    {
      name: '29Jan2026_US_BankTransfer_Acme',
      counts: {
        approvalRequired: 1,
        trusteeApprovalRequired: 0,
        agentApprovalRequired: 0,
        managerApprovalRequired: 0,
        approved: 4,
        cancelled: 5,
        inTransit: 4,
        paid: 2,
        total: 12
      },
      detailedCounts: [
        { type: 'bank_transfer', status: 'approvalRequired', count: 1 },
        { type: 'bank_transfer', status: 'approved', count: 2 },
        { type: 'bank_transfer', status: 'paid', count: 3 }
      ],
      createdAt: '2026-01-29T15:57:52.797Z',
      createdBy: 'staging_account_1234',
      endDate: '2026-01-15T23:59:59.999Z',
      foundationId: 'staging_foundation_1234',
      id: 'staging_disbursementbatch_1234'
    },
    {
      name: '29Dec2025_UK_Cheque',
      counts: {
        approvalRequired: 0,
        trusteeApprovalRequired: 0,
        agentApprovalRequired: 0,
        managerApprovalRequired: 0,
        approved: 2,
        cancelled: 0,
        inTransit: 0,
        paid: 3,
        total: 5
      },
      detailedCounts: [
        { type: 'cheque', status: 'approved', count: 2 },
        { type: 'cheque', status: 'paid', count: 3 }
      ],
      createdAt: '2025-12-16T09:12:00.000Z',
      createdBy: 'staging_account_1234',
      endDate: '2025-12-15T23:59:59.999Z',
      foundationId: 'staging_foundation_1234',
      id: 'staging_disbursementbatch_2345'
    },
    {
      name: '31Dec2025_US_Card',
      counts: {
        approvalRequired: 0,
        trusteeApprovalRequired: 0,
        agentApprovalRequired: 0,
        managerApprovalRequired: 0,
        approved: 0,
        cancelled: 0,
        inTransit: 0,
        paid: 7,
        total: 7
      },
      detailedCounts: [{ type: 'card', status: 'paid', count: 7 }],
      createdAt: '2025-12-31T11:30:00.000Z',
      createdBy: 'staging_account_1234',
      endDate: '2025-12-31T23:59:59.999Z',
      foundationId: 'staging_foundation_1234',
      id: 'staging_disbursementbatch_3456'
    }
  ],
  object: 'disbursement_batch',
  totalResults: 3,
  _links: {
    current: 'https://staging-api.poweredbypercent.com//v1/admin/disbursement-batches?pageSize=25'
  }
}

/** Exercises the legacy table's flagged count columns and the Sent column's inTransit summing. */
export const mockDisbursementsListWithFlaggedCounts = {
  data: [
    {
      name: 'Flagged counts batch',
      counts: {
        approvalRequired: 1,
        trusteeApprovalRequired: 0,
        agentApprovalRequired: 0,
        managerApprovalRequired: 0,
        approved: 4,
        cancelled: 6,
        inTransit: 4,
        paymentInitiated: 3,
        paid: 2,
        returned: 2,
        failed: 5,
        total: 27
      },
      detailedCounts: [
        { type: 'bank_transfer', status: 'approvalRequired', count: 1 },
        { type: 'bank_transfer', status: 'paid', count: 2 },
        { type: 'bank_transfer', status: 'returned', count: 2 },
        { type: 'bank_transfer', status: 'failed', count: 5 }
      ],
      createdAt: '2026-01-29T15:57:52.797Z',
      createdBy: 'staging_account_1234',
      endDate: '2026-01-15T23:59:59.999Z',
      foundationId: 'staging_foundation_1234',
      id: 'staging_disbursementbatch_4567'
    }
  ],
  object: 'disbursement_batch',
  totalResults: 1,
  _links: {
    current: 'https://staging-api.poweredbypercent.com//v1/admin/disbursement-batches?pageSize=25'
  }
}

export const mockDisbursementsListEmpty = {
  data: [],
  object: 'disbursement_batch',
  totalResults: 0,
  _links: {
    current: 'https://staging-api.poweredbypercent.com//v1/admin/disbursement-batches?pageSize=25'
  }
}
